<template src="./About.html"></template>

<script>
import Form from 'components/form/Form';
import { onWaypoint, parallax } from 'src/mixins';

export default {
  mixins: [onWaypoint, parallax],
  components: {
    Form,
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/vars.scss";

.about_letters-wrapper{
  position: relative;
  margin: 0 auto;
  width: 1075px;
}

.about_letters{
  position: absolute;
  width: 100%;

  p{
    color: $blue;
    font-family: $playfair;
    font-size: 323px;
    position: absolute;

    &:nth-child(1){
      top: -186px;
      left: -131px;
    }

    &:nth-child(2){
      right: -95px;
      top: 27px;
    }

    &:nth-child(3){
      left: 50%;
      margin-left: -100px;
      top: 612px;
    }
    &:nth-child(4){
      right: -54px;
      top: 1185px;
    }
    &:nth-child(5){
      left: 110px;
      top: 1482px;
    }
    &:nth-child(6){
      right: -23px;
      top: 2132px;
    }
    &:nth-child(7){
      left: 325px;
      top: 2685px;
    }
    &:nth-child(8){
      left: -270px;
      top: 3232px;
    }
  }

  @media only screen and (max-width : $tablet){
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/About.vue